import { TuiDialogModule, TuiRootModule, TuiAlertModule } from '@taiga-ui/core';
import { NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
const cubejsOptions = {
  token:
    'eyJhbGciOiJIUzI1NiJ9.eyJSb2xlIjoiQWRtaW4iLCJJc3N1ZXIiOiJPbmxpbmUiLCJVc2VybmFtZSI6Ik11dG9uZGkiLCJleHAiOjIwMjU2ODQ2MjAsImlhdCI6MTcxMDE1MTgyMH0.HSmz-darEZQy5cL-V6HTZ4ZP6v6qKRkIKTyHqeziCUk',
  options: {
    apiUrl: 'https://analytics.fuelcapphealthtech.link/cubejs-api/v1',
  },
};
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { LicenseManager } from 'ag-grid-enterprise';

LicenseManager.setLicenseKey(
  'DownloadDevTools_COM_NDEwMjM0NTgwMDAwMA==59158b5225400879a12a96634544f5b6'
);

import { Overlay, OverlayModule } from '@angular/cdk/overlay';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

//s
registerLocaleData(en);
import { CubeClientModule } from '@cubejs-client/ngx';

//import * as ADDON_EDITOR from '@taiga-ui/addon-editor';

import { MatNativeDateModule } from '@angular/material/core';
import { PaymentsPipe } from './modals/payments.pipe';

@NgModule({
  declarations: [AppComponent, PaymentsPipe],
  imports: [
    BrowserModule,
    TuiRootModule,
    MatAutocompleteModule,

    IonicModule.forRoot(),
    AppRoutingModule,
    OverlayModule,
    HttpClientModule,
    BrowserAnimationsModule,
    CubeClientModule.forRoot(cubejsOptions),

    FormsModule,
    ReactiveFormsModule,
    TuiAlertModule,
    OverlayModule,

    TuiDialogModule,

    MatNativeDateModule,
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },

    Title,
    { provide: Overlay, useClass: Overlay },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {}
}
